/**
 * Shared token resolution utilities used by both useAuthClient (Axios) and
 * apolloAuthLink (Apollo)
 */

/**
 * The checkout access token key — stored as a cookie by the checkout flow.
 * Used as a fallback when Auth0 token is unavailable (e.g. guest checkout).
 */
export const CHECKOUT_ACCESS_TOKEN_COOKIE = 'checkoutAccessToken';

/**
 * Reads the checkout access token from cookies.
 * Returns the raw token string or null if not present.
 */
export const getCheckoutTokenFromCookies = (): string | null => {
  if (typeof document === 'undefined') {
    return null;
  }
  const match = document.cookie
    .split(';')
    .map(c => c.trim())
    .find(c => c.startsWith(`${CHECKOUT_ACCESS_TOKEN_COOKIE}=`));
  if (!match) {
    return null;
  }
  const value = match.split('=').slice(1).join('=');
  if (!value) {
    return null;
  }
  try {
    const parsed = JSON.parse(value);
    return typeof parsed === 'string' ? parsed : null;
  } catch {
    return value;
  }
};

export const isTokenExpired = (token: string | null | undefined): boolean => {
  if (typeof window === 'undefined' || !token) {
    return false;
  }

  try {
    const { exp } = JSON.parse(atob(token.split('.')[1]));
    return exp < Math.floor(Date.now() / 1000);
  } catch {
    return true;
  }
};
